module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('el-form', {
    ref: "resetForm",
    attrs: {
      "model": _vm.user
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current Password",
      "prop": "currPass"
    }
  }, [_c('el-input', {
    staticClass: "pass-reset",
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.cur),
      callback: function($$v) {
        _vm.$set(_vm.password, "cur", $$v)
      },
      expression: "password.cur"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Password",
      "prop": "newPass"
    }
  }, [_c('el-input', {
    staticClass: "pass-reset",
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.new),
      callback: function($$v) {
        _vm.$set(_vm.password, "new", $$v)
      },
      expression: "password.new"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticClass: "pass-reset",
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.new2),
      callback: function($$v) {
        _vm.$set(_vm.password, "new2", $$v)
      },
      expression: "password.new2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Submit")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Change Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d3e3372","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePassForm.vue
// module id = 648
// module chunks = 14 16